import { Component } from '@angular/core';

import { AuthenticationLayoutComponent } from '#/app/core/layouts/authentication/authentication-layout';
import { SpinnerComponent } from '#/app/shared/ui/spinner/spinner';

/**
 * Page to handle Entra Id SSO redirects
 */
@Component({
  selector: 'app-auth-entra-id-sso-redirect',
  imports: [AuthenticationLayoutComponent, SpinnerComponent],
  template: `<app-authentication-layout>
    <app-spinner ariaLabel="Redirecting..." diameter="40" fullWidth />
  </app-authentication-layout>`,
})
export class AuthEntraIdSsoComponent {}
